import IconWrapper from './IconWrapper';

const IconStep = IconWrapper({
  name: 'step',
  source: (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.56152 15.5088C3.93628 15.3326 4.38323 15.4934 4.55957 15.8682C5.24625 17.3271 6.33387 18.5608 7.69531 19.4248C9.05689 20.2888 10.6364 20.748 12.249 20.748C12.6631 20.7482 12.999 21.0839 12.999 21.498C12.9989 21.9121 12.6631 22.2479 12.249 22.248C10.3518 22.248 8.49351 21.7079 6.8916 20.6914C5.28978 19.6749 4.01003 18.2234 3.20215 16.5068C3.02578 16.132 3.18673 15.6852 3.56152 15.5088Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.498 11.499C21.912 11.4992 22.2479 11.8351 22.248 12.249C22.248 14.1463 21.7079 16.0045 20.6914 17.6064C19.6747 19.2085 18.2227 20.488 16.5059 21.2959C16.1311 21.4721 15.6841 21.3112 15.5078 20.9365C15.3319 20.5619 15.4927 20.1148 15.8672 19.9385C17.3264 19.2518 18.5606 18.1644 19.4248 16.8027C20.2889 15.4411 20.748 13.8616 20.748 12.249C20.7482 11.835 21.084 11.4991 21.498 11.499Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.04785 11.0449C3.46115 11.0653 3.78055 11.4178 3.76074 11.8311L3.75 12.248L3.76074 12.665C3.78106 13.0787 3.46143 13.4307 3.04785 13.4512C2.63448 13.4712 2.28323 13.1526 2.2627 12.7393C2.2547 12.5762 2.25 12.4116 2.25 12.248L2.2627 11.7578C2.28339 11.3446 2.6346 11.0249 3.04785 11.0449Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.20996 7.97363C3.38726 7.59973 3.8348 7.43932 4.20898 7.61621C4.58302 7.79321 4.74279 8.24005 4.56641 8.61426C4.50712 8.73961 4.45065 8.86771 4.39746 8.99609C4.34434 9.12436 4.29376 9.25433 4.24707 9.38477C4.10754 9.77473 3.67806 9.97834 3.28809 9.83887C2.89829 9.69924 2.69552 9.26977 2.83496 8.87988C2.88995 8.72624 2.94914 8.57296 3.01172 8.42188C3.07423 8.271 3.14029 8.12096 3.20996 7.97363Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.249 2.25C14.1463 2.25004 16.0045 2.7901 17.6064 3.80664C19.2083 4.8232 20.488 6.27467 21.2959 7.99121C21.4723 8.366 21.3113 8.81289 20.9365 8.98926C20.5618 9.16551 20.1148 9.00462 19.9385 8.62988C19.2518 7.17094 18.1642 5.93726 16.8027 5.07324C15.4412 4.20922 13.8616 3.75004 12.249 3.75C11.8349 3.74991 11.499 3.41416 11.499 3C11.4992 2.58596 11.835 2.25009 12.249 2.25Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.53418 4.83984C5.841 4.56225 6.31569 4.58516 6.59375 4.8916C6.87175 5.19833 6.84838 5.67293 6.54199 5.95117C6.43923 6.04431 6.33755 6.14001 6.23926 6.23828C6.14098 6.33656 6.04529 6.43826 5.95215 6.54102C5.67397 6.84787 5.19947 6.87092 4.89258 6.59277C4.58592 6.31457 4.56273 5.84003 4.84082 5.5332C4.95036 5.41237 5.06314 5.2933 5.17871 5.17773C5.29429 5.06217 5.41334 4.94938 5.53418 4.83984Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.88086 2.83398C9.27047 2.69491 9.7001 2.89776 9.83984 3.28711C9.97934 3.67696 9.77545 4.10638 9.38574 4.24609C9.25522 4.2928 9.12542 4.34333 8.99707 4.39648C8.86861 4.44969 8.74066 4.50612 8.61523 4.56543C8.24087 4.74234 7.79428 4.58231 7.61719 4.20801C7.44047 3.83367 7.60033 3.386 7.97461 3.20898C8.12201 3.13929 8.27189 3.07327 8.42285 3.01074C8.57402 2.94814 8.72713 2.88899 8.88086 2.83398Z"
      />
    </svg>
  ),
});

export default IconStep;
